import { memo } from 'react';

import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import AppTypography from '@components/common/AppTypography';

const AppEmptyState = memo(function AppEmptyState({
  title = 'Nothing here yet',
  description = 'There is no content to display.',
  icon = <InboxOutlinedIcon fontSize="large" color="disabled" />,
  action,
  sx,
  ...rest
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        py: 6,
        px: 2,
        ...sx,
      }}
      {...rest}
    >
      {icon}
      <AppTypography variant="h6">{title}</AppTypography>
      {description ? (
        <AppTypography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
          {description}
        </AppTypography>
      ) : null}
      {action}
    </Box>
  );
});

AppEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
  action: PropTypes.node,
  sx: PropTypes.object,
};

export default AppEmptyState;
